import React from 'react';
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import constants from "./constants";
import reportConstants from "../../constants";
import {
  formatShipmentsStatusCodesForTooltip,
  getStopServiceWindowByStopType
} from '../../../../Dispatch/utils/utils';
import { getMergedCustomerLabel } from '../../../../../common/utils';
import { UnarriveIndicator, RevisitIcon } from '../../../../Dispatch/icons';
import LateByIcon from '../../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/LateByIcon';
import StyledToolTip from '@StyledToolTip';

const PickupDeliveryPopupRenderer = ({
  stopType,
  isReturn,
  arrivalTime,
  departureTime,
  stopTime,
  serviceWindow,
  statusLabel,
  statusValue,
  stopStatusClass,
  departureTimeLabel,
  arrivalTimeLabel,
  stopTimeLabel,
  statusCodes,
  classes,
  stopData,
  stopTimeClass,
  stopTimeHeaderClass,
  theme,
  enableRevisitDeliveryStop
}) => {
  const shouldShowPickupNumber =
    stopType === reportConstants.DISPATCH_STOP_TYPES.PICKUP &&
    stopData?.pickupNumber;

  const shouldShowProNumber =
    stopType === reportConstants.DISPATCH_STOP_TYPES.DELIVERY && stopData?.shipments?.length > 0;

  const getProIdOrPickupNumberListValue = (fieldName, dataKey) => {
    if (!stopData?.shipments?.length) return null;

    const uniqueValues = Array.from(
      new Set(stopData.shipments.map(shipment => shipment[fieldName]))
    );

    return getListValue(uniqueValues, dataKey);
  };
  const getListValue = (uniqueValues, dataKey) => {
    return uniqueValues.map((value, index) => (
      <React.Fragment key={value}>
        <span
          className={classes.hyperlink}
          data-stopid={stopData.stopId}
          {...{ [dataKey]: value }}
        >
          {value}
        </span>
        {index < uniqueValues.length - 1 && <span>, </span>}
      </React.Fragment>
    ));
  };
  const statusCodeTooltip = formatShipmentsStatusCodesForTooltip(stopData?.shipments);
  const pickupNumber = stopData?.shipments?.length > 0 ? getProIdOrPickupNumberListValue('pickupNumber', 'data-pickupnumber')
  : getListValue([stopData?.pickupNumber], 'data-pickupnumber');
  const stopDelayNames =  Array.isArray(stopData?.delaysTakenInPNDStop) ? stopData.delaysTakenInPNDStop.filter(Boolean) : [];
  const stopTimeValue = stopDelayNames.length > 0 && (
    <div >
      {stopDelayNames.map((delayName, index) => (
          <span key={`${delayName}-${index}`} className={classes.delayNameRow}>
            <LateByIcon color={theme.violationColor} width={14} height={14} />
            <span className={classes.delayNameValue}>{delayName}</span>
          </span>
      ))}
    </div>
  )
  return (
    <div className={classes.popupContainer}>
      <div className={classes.headerRowWrapper}>
        <PopupFieldRenderer
          label={stopType}
          value={getMergedCustomerLabel(stopData?.displayCustomerName, stopData?.name)}
          valueClassName={classes.headerRowValue}
          rowClassName={classes.headerRowContainer}
          labelClassName={
            isReturn ? `${classes.headerLabel} ${classes.violation}` : classes.headerLabel
          }
        />
        {stopData.unarrivedReason && (
          <UnarriveIndicator
            color={theme.TextColor}
            size={14}
            unarrivedReason={stopData.unarrivedReason}
            className={classes.unarriveIcon}
          />
        )}
        {enableRevisitDeliveryStop && stopData.isStopCreatedFromRevisit && (
          <StyledToolTip title="Revisit Stop">
            <div className={classes.revisitIcon}>
              <RevisitIcon color={theme.TextColor} size={12} />
            </div>
          </StyledToolTip>
        )}
      </div>
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer
          label={arrivalTimeLabel ?? constants.POPUP_LABELS.ARRIVAL_TIME}
          value={arrivalTime}
          rowClassName={classes[stopTimeHeaderClass]}
        />
        <div className={classes.rowContainerRight}>
          <PopupFieldRenderer
            label={departureTimeLabel ?? constants.POPUP_LABELS.DEPARTURE_TIME}
            value={departureTime}
          />
        </div>
      </div>
      <div className={classes.multipleColumnRowContainer}>
        <div className={classes.stopDelaysContainer}>
          <PopupFieldRenderer
            label={stopTimeLabel ?? constants.POPUP_LABELS.STOP_TIME}
            value={stopTime}
            valueClassName={classes[stopTimeClass]}
            rowClassName={classes[stopTimeHeaderClass]}
            />
          {stopTimeValue}
        </div>
        <div className={classes.rowContainerRight}>
          <PopupFieldRenderer
            label={statusLabel}
            value={statusValue}
            valueClassName={`${classes[stopStatusClass]} ${classes.statusValue}`}
            statusCodeValue={statusCodes ?? null}
            statusCodeTooltip={statusCodeTooltip}
          />
        </div>
      </div>
      <div className={classes.multipleColumnRowContainer}>
        <PopupFieldRenderer
          label={constants.POPUP_LABELS.SERVICE_WINDOW}
          value={getStopServiceWindowByStopType(serviceWindow)}
          valueClassName={classes.statusValue}
          rowClassName={classes[stopTimeHeaderClass]}
        />
      </div>
      {shouldShowPickupNumber && (
        <PopupFieldRenderer
          label={constants.POPUP_LABELS.PICKUP_NUMBER}
          value={pickupNumber}
          valueClassName={classes.proNumberValue}
        />
      )}
      {shouldShowProNumber && (
        <PopupFieldRenderer
          label={constants.POPUP_LABELS.PRO_NUMBER}
          value={getProIdOrPickupNumberListValue('proId', 'data-pronumber')}
          valueClassName={classes.proNumberValue}
        />
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PickupDeliveryPopupRenderer);
